<template>
  <div class="page">
    <div class="topif2" v-if="type == 1">
      <img src="../../assets/images/checkisok.png" alt="" v-if="xiezuozuzt == 'tg'" />
      <img src="../../assets/images/checkisno.png" alt="" v-else-if="xiezuozuzt == 'jj'" />
      <img src="../../assets/images/checkissh.png" alt="" v-else-if="xiezuozuzt == 'spz'" />
      <div class="toptext" v-if="xiezuozuzt == 'tg'">审批通过</div>
      <div class="toptext" v-else-if="xiezuozuzt == 'jj'">申请拒绝</div>
      <div class="toptext" alt="" v-else-if="xiezuozuzt == 'spz'">审批中</div>
    </div>
    <div class="main">
      <div class="mainrow" v-if="type == 1">
        <div v-if="xiezuozuzt == 'spz' || xiezuozuzt == 'tg'">
          <div class="rowrow" v-for="(item, index) in list" :key="index">
            <div class="rowname">{{ item.Title }}</div>
          </div>
        </div>
        <div v-else-if="xiezuozuzt == 'jj'">
          <div class="rowrow" v-for="(item, index) in list" :key="index">
            <div class="rowname">{{ item.Title }}</div>
            <div class="rowjj">拒绝理由：{{ item.CheckInformation }}</div>
          </div>
        </div>
      </div>

      <div class="mainrow1" v-if="type == 2">
        <div class="rowin">
          <div class="rowrow1" v-for="(item, index) in list" :key="index">
            <div class="rowrow1in">
              <div class="inleft">
                <img src="../../assets/images/checkisok.png" alt="" v-if="item.CheckStatus == 20" />
                <img src="../../assets/images/checkisno.png" alt="" v-else-if="item.CheckStatus == 30" />
                <img src="../../assets/images/checkissh.png" alt="" v-else-if="item.CheckStatus == 10" />
              </div>
              <div class="inright">
                <div class="rowstat" v-if="item.CheckStatus == 20">审批通过</div>
                <div class="rowstat" v-else-if="item.CheckStatus == 30">申请拒绝</div>
                <div class="rowstat" v-else-if="item.CheckStatus == 10">审批中</div>
                <div class="rowname">{{ item.Title }}</div>
              </div>
            </div>
            <div class="rowjj" v-if="item.CheckStatus == 30">拒绝理由：{{ item.CheckInformation }}</div>
          </div>
        </div>
      </div>
      <div class="oktogroup" v-if="choise != 0">
        <button class="sqbtn" @click="togrouplist()">继续申请</button>
      </div>
      <div class="qrcode">
        <img src="../../assets/images/acmedXSZS.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from "core-js/fn/map";
import { Dialog } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  name: "mine",
  data() {
    return {
      xiezuozuzt: '获取中',
      type: 0,
      list: [],
      choise: 0,
    };
  },
  created() {
    this.$store.commit("changeNavbarIndex", 3);
    this.getGroup();
    document.title = "华肤荟";
  },
  methods: {
    getGroup() {
      let that = this;
      this.$axios.post('/api/api/web/Customer/GetCollaborativeGroupCustomerList').then(res => {
        const status = res.Data;
        that.list = res.Data;
        if (status.length == 1) {
          // console.log('123123')
          if (status[0].CheckStatus == 10) {
            that.xiezuozuzt = 'spz';
            that.type = 1
            that.choise = 1
          } else if (status[0].CheckStatus === 20) {
            that.xiezuozuzt = 'tg';
            that.type = 1
            that.choise = 1
          } else if (status[0].CheckStatus === 30) {
            that.xiezuozuzt = 'jj';
            that.type = 1
            that.choise = 2
          }
        } else if (status.length == 2) {
          const [s1, s2] = [res.Data[0].CheckStatus, res.Data[1].CheckStatus];
          const allStatus = new Set([s1, s2]); // 去重判断状态类型
          // 2条全审核中
          if (allStatus.size === 1 && allStatus.has(10)) {
            that.xiezuozuzt = 'spz';
            that.type = 1
            that.choise = 0
            // console.log('2条数据：全部审核中')
          }
          // 2条全通过
          else if (allStatus.size === 1 && allStatus.has(20)) {
            that.xiezuozuzt = 'tg';
            that.type = 1
            that.choise = 0
            // console.log('2条数据：全部审核通过')
          }
          // 2条全拒绝
          else if (allStatus.size === 1 && allStatus.has(30)) {
            that.xiezuozuzt = 'jj';
            that.type = 1
            that.choise = 2
            // console.log('2条数据：全部审核拒绝')
          }
          // 混合：审核中 + 通过
          else if (allStatus.has(10) && allStatus.has(20)) {
            that.xiezuozuzt = 'else';
            that.type = 2
            that.choise = 0
            // console.log('2条数据：审核中 + 审核通过')
          }
          // 混合：审核中 + 拒绝
          else if (allStatus.has(10) && allStatus.has(30)) {
            that.xiezuozuzt = 'else';
            that.type = 2
            that.choise = 1
            // console.log('2条数据：审核中 + 审核拒绝')
          }
          // 混合：通过 + 拒绝
          else if (allStatus.has(20) && allStatus.has(30)) {
            that.xiezuozuzt = 'else';
            that.type = 2
            that.choise = 1
            // console.log('2条数据：审核通过 + 审核拒绝')
          }
        }
      });
      // console.log('协作组状态' + that.xiezuozuzt)
    },
    togrouplist() {
      let that = this
      this.$router.push({
        name: "grouplist",
        query: { choise: that.choise }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: rgb(247, 248, 252);
  width: 100%;
  height: 100%;
  // padding-bottom: 2rem;
}

.topif2 {
  text-align: center;
  padding-top: 0.5rem;

  img {
    width: 15%;
    margin-bottom: .3rem;
  }
}

.toptext {
  font-weight: bold;
  color: #0c2941;
}

.main {
  // margin-top: .5rem;
}

.mainrow {
  width: 80%;
  margin: auto;
  font-weight: bold;
  color: #0c2941;
}

.mainrow1 {
  width: 80%;
  margin: auto;
  padding-top: .5rem;
  font-weight: bold;
  color: #0c2941;
}

.rowrow {
  padding: .5rem 0;
  border-bottom: 1px dashed #c1c1c1;
}

.rowname {
  font-size: .45rem;
}

.rowjj {
  margin-top: .2rem;
}

.rowrow1 {
  padding: .5rem 0;
  border-bottom: 1px dashed #c1c1c1;
}

.rowrow1in {
  display: flex;
  flex-direction: row;
}

.inleft {
  width: 20%;

  img {
    width: 72%;
  }
}

.inright {
  width: 80%;
}

.rowstat {
  font-weight: bold;
}

.oktogroup {
  margin-top: .5rem;
}

.sqbtn {
  display: block;
  border: 0;
  padding: 0.2rem 1rem;
  margin: auto;
  border-radius: 3rem;
  color: #fff;
  background: #2B3764;
}

.qrcode {
  margin-top: 1.5rem;

  img {
    width: 50%;
    display: block;
    margin: auto;
  }
}
</style>